import t from"eventemitter3";class e extends t{constructor(t){super(),this.walletClientType=t,this.connected=!1,this.initialized=!1}}export{e as WalletConnector};
